var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operations-history default-container"},[_c('back-link',{staticClass:"mb-5"}),(_vm.model)?_c('operations-list',{attrs:{"model":_vm.model,"statusFilter":true,"contractFilter":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }